import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m7.83 16.142.488 1.096a1.843 1.843 0 0 0 3.37 0l.487-1.096a2.02 2.02 0 0 1 2.059-1.186l1.191.127a1.843 1.843 0 0 0 1.685-2.918l-.705-.97A2.02 2.02 0 0 1 16.022 10c0-.428.135-.845.387-1.19l.705-.97a1.842 1.842 0 0 0-.655-2.728 1.84 1.84 0 0 0-1.03-.19l-1.192.126a2.02 2.02 0 0 1-2.058-1.19l-.49-1.096a1.842 1.842 0 0 0-3.371 0L7.83 3.857a2.02 2.02 0 0 1-2.059 1.191l-1.195-.127A1.844 1.844 0 0 0 2.892 7.84l.706.97a2.02 2.02 0 0 1 0 2.38l-.706.97a1.843 1.843 0 0 0 1.685 2.919l1.192-.127a2.03 2.03 0 0 1 2.062 1.19"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.002 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1)
  ]))]))
}
export default { render: render }